import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { env } from '../utils/functions';

export function useManifestGenerator(config, backofficeConfig) {
  const [frame, setFrame] = useState(config.data.frame);

  const assetsDAM =
    backofficeConfig?.definingAttributes?.assetsDAM ||
    config?.baseURLs?.assetsDAM;

  const {
    data: manifestJson,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['manifestGenerator'],
    queryFn: async () => {
      const environment = env(); //process.env.REACT_APP_ENVIRONMENT_URL;
      const manifestEnv = environment === 'prod' ? 'manifest' : 'manifest-uat';
      const response = await axios.get(
        `${backofficeConfig?.definingAttributes?.assetsCDN}/manifest-generator/${manifestEnv}/RoxConfigurator/${config.data.frame.upc}_manifest_3.json`
      );
      return response?.data;
    },
    enabled: assetsDAM && (!frame?.imageUrl || !frame?.color || !frame?.model),
  });

  const getImageUrl = (manifestJson, assetsDAM) => {
    const quarterImage = manifestJson?.payload?.images?.find(
      (image) => image.view === 'Quarter'
    );
    if (quarterImage && assetsDAM) {
      return `${assetsDAM}${quarterImage.path}`;
    } else {
      return null;
    }
  };

  useEffect(() => {
    if (manifestJson?.payload) {
      setFrame({
        ...frame,
        imageUrl:
          frame?.imageUrl || getImageUrl(manifestJson, assetsDAM) || 'error',
        color: frame?.color || manifestJson.mocoId.colorCode,
        model: frame?.model || manifestJson.mocoId.model,
      });
    }
  }, [assetsDAM, manifestJson, isLoading, isError]);

  if (
    !frame?.imageUrl ||
    !frame?.color ||
    !frame?.model ||
    isLoading ||
    isError
  )
    return null;

  return frame;
}
